var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardPolicies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard-policies",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.359,
    height: 65.359,
    viewBox: "0 0 65.359 65.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_418721",
    "data-name": "Path 418721",
    d: "M28.34,48.126a2.044,2.044,0,0,1-.8-.163C26.907,47.693,12,41.2,12,27.848V16.906a2.042,2.042,0,0,1,1.386-1.934l14.3-4.864a2.044,2.044,0,0,1,1.313,0l14.3,4.864a2.042,2.042,0,0,1,1.386,1.934V27.848c0,13.352-14.907,19.845-15.539,20.117a2.091,2.091,0,0,1-.8.161ZM16.085,18.368v9.477c0,9.077,9.412,14.534,12.255,15.972,2.843-1.438,12.255-6.9,12.255-15.972V18.368L28.34,14.2Z",
    transform: "translate(20.68 17.234)",
    fill: "#0095d9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418722",
    "data-name": "Path 418722",
    d: "M22.489,28.978a2.027,2.027,0,0,1-1.443-.6L15.6,22.932a2.043,2.043,0,0,1,2.889-2.889l3.783,3.783,6.754-9.009a2.042,2.042,0,1,1,3.265,2.454L24.12,28.164a2.04,2.04,0,0,1-1.49.812l-.142,0Z",
    transform: "translate(25.85 24.126)",
    fill: "#0095d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418723",
    "data-name": "Path 418723",
    d: "M28.84,57.189H7.489A7.5,7.5,0,0,1,0,49.7V7.489A7.5,7.5,0,0,1,7.489,0H38.807A7.5,7.5,0,0,1,46.3,7.489V22.277a2.042,2.042,0,1,1-4.085,0V7.489a3.409,3.409,0,0,0-3.4-3.4H7.489a3.409,3.409,0,0,0-3.4,3.4V49.7a3.409,3.409,0,0,0,3.4,3.4H28.84a2.042,2.042,0,1,1,0,4.085Z",
    fill: "#0095d9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418724",
    "data-name": "Path 418724",
    d: "M30.914,12.085H5.042A2.042,2.042,0,1,1,5.042,8H30.914a2.042,2.042,0,1,1,0,4.085Z",
    transform: "translate(5.17 13.786)",
    fill: "#0095d9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418725",
    "data-name": "Path 418725",
    d: "M20.021,16.085H5.042a2.042,2.042,0,0,1,0-4.085H20.021a2.042,2.042,0,0,1,0,4.085Z",
    transform: "translate(5.17 20.68)",
    fill: "#0095d9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418726",
    "data-name": "Path 418726",
    d: "M17.3,8.085H5.042A2.042,2.042,0,1,1,5.042,4H17.3a2.042,2.042,0,1,1,0,4.085Z",
    transform: "translate(5.17 6.893)",
    fill: "#0095d9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPolicies);
export default __webpack_public_path__ + "static/media/dashboard-policies.dcf2135d76ae92c5370ae9afb3d1e8e6.svg";
export { ForwardRef as ReactComponent };